<template> 
        <img :src="url" 
             :title="fragment.title"
             class="img-fluid e2e-image"/> 
</template>

<script> 
import { resolveUrl } from "../layout-bom";

/**
 * fragment.url = Link (ggf relativ) zum Bild
 * fragment.title = Beschreibung des Bildes
 */
export default {
  name: "fragment-image",
  props: ["fragment"],
  computed: {
    url() {
      const url = this.fragment.url;
      return resolveUrl(url);
    }
  }
};
</script>
 

<style scoped>
</style>